<template>
    <div>
        <el-table :data="tableData" :default-sort="{prop: 'datetime', order: 'descending'}">
            <el-table-column prop="datetime" sortable width="200px" :formatter="date_formatter" label="Дата">
            </el-table-column>
            <el-table-column prop="amount" sortable width="110px" label="Кількісь">
            </el-table-column>
            <el-table-column prop="category.display_name" width="200px" label="Категорія">
            </el-table-column>
            <el-table-column prop="description" label="Опис">
            </el-table-column>
            <el-table-column label="Дії" width="150px">
                <template slot-scope="scope">
                    <el-button
                    icon="el-icon-edit"
                    @click="handleEdit(scope.row)"></el-button>
                    <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, tableData, scope.row.id)"></el-button>
                </template>
                </el-table-column>
        </el-table>
        <TransactionEditor 
            :dialogFormVisible="dialogFormVisible"
            :selected_transaction="selected_transaction" 
            :categories="categories" 
            @close="dialogFormVisible = false"
            @save="saveForm"
        />

    </div>
</template>
<script>
import moment from 'moment';
import { deleteTransaction, updateTransaction } from "@/api/transactions.api";

import TransactionEditor from '@/components/TransactionEditor'

export default {
    props: ['tableData', 'categories'],
    components: {
        TransactionEditor
    },
    data: () => ({
        dialogFormVisible: false,
        selected_transaction: {},
    }),
    methods: {
        date_formatter(row) {
            return moment(row.datetime).format('DD.MM.YYYY H:mm');
        },
        handleEdit(row) {
            this.selected_transaction = row;
            this.dialogFormVisible = true;
        },
        async handleDelete(index, rows, transaction_id) {
            const response = await deleteTransaction(transaction_id);
            if (response.status == 204){
                this.$message({
                    message: 'Транзакцію успішно видалено!',
                    type: 'success',
                    duration: 2000
                });
                rows.splice(index, 1);
            } else {
                this.$message({
                    message: 'Транзакцію не видалено!',
                    type: 'error',
                    duration: 2000
                });
            }
        },
        async saveForm() {
            let updated_form = {
                "category": this.selected_transaction.category.id,
                "description": this.selected_transaction.description,
                "planned_transaction": this.selected_transaction.planned_transaction
            }
            const response = await updateTransaction(this.selected_transaction.id, updated_form);
            if (response.status == 200){
                this.$message({
                    message: 'Транзакцію успішно оновлено!',
                    type: 'success',
                    duration: 2000
                });
                this.dialogFormVisible = false;
            } else {
                this.$message({
                    message: 'Транзакцію не оновлено!',
                    type: 'error',
                    duration: 2000
                });
            }
        }
    }
}
</script>
<style>
textarea {
    font-family: Helvetica, Arial, sans-serif;
}
</style>